import TaxiCorporationListRequest from "../../api/raily/taxi-corporation/list/taxi-corporation-list.request";
import taxiCorporationApiService from "../../api/raily/taxi-corporation/taxi-corporation-api.service";
import dataLoadErrorFactory from "../../utils/data-load-error/data-load-error.factory";
import HttpError from "../../utils/http/http.error";
import TaxiCorporationDetailsError from "./details/taxi-corporation-details-error";
import TaxiCorporationDetailsParams from "./details/taxi-corporation-details-params";
import taxiCorporationDetailsFactory from "./details/taxi-corporation-details.factory";
import TaxiCorporationListError from "./list/taxi-corporation-list-error";
import TaxiCorporationList from "./list/taxi-corporation-list";
import TaxiCorporationListParams from "./list/taxi-corporation-list-params";
import taxiCorporationListParamsFactory from "./list/taxi-corporation-list-params.factory";
import taxiCorporationListFactory from "./list/taxi-corporation-list.factory";
import TaxiCorporationAddError from "./add/taxi-corporation-add-error";
import TaxiCorporationAddParams from "./add/taxi-corporation-add-params";
import TaxiCorporationAddRequest from "../../api/raily/taxi-corporation/add/taxi-corporation-add-request";
import taxiCorporationAddParamsFactory from "./add/taxi-corporation-add-params.factory";
import TaxiCorporationCargoTaxiContractListError from "./cargo-taxi-contract/list/taxi-corporation-cargo-taxi-contract-list-error";
import TaxiCorporationCargoTaxiContractListParams from "./cargo-taxi-contract/list/taxi-corporation-cargo-taxi-contract-list-params";
import TaxiCorporationCargoTaxiContractList from "./cargo-taxi-contract/list/taxi-corporation-cargo-taxi-contract-list";
import TaxiCorporationCargoTaxiContractListRequest from "../../api/raily/taxi-corporation/cargo-taxi-contract/list/taxi-corporation-cargo-taxi-contract-list.request";
import taxiCorporationCargoTaxiContractListParamsFactory from "./cargo-taxi-contract/list/taxi-corporation-cargo-taxi-contract-list-params.factory";
import taxiCorporationCargoTaxiContractListFactory from "./cargo-taxi-contract/list/taxi-corporation-cargo-taxi-contract-list.factory";
import TaxiCorporationPlanEntryBillingsError from "./plan-entry-billings/list/taxi-corporation-plan-entry-billings-error";
import TaxiCorporationPlanEntryBillingsParams from "./plan-entry-billings/list/taxi-corporation-plan-entry-billings-params";
import TaxiCorporationPlanEntryBillings from "./plan-entry-billings/list/taxi-corporation-plan-entry-billings";
import taxiCorporationPlanEntryBillingsFactory from "./plan-entry-billings/list/taxi-corporation-plan-entry-billings.factory";
import taxiCorporationPlanEntryBillingsParamsFactory from "./plan-entry-billings/list/taxi-corporation-plan-entry-billings-params.factory";
import TaxiCorporationPlanEntryBillingsDownloadError from "./plan-entry-billings/download/taxi-corporation-plan-entry-billings-download-error";
import TaxiCorporationPlanEntryBillingsDownloadParams from "./plan-entry-billings/download/taxi-corporation-plan-entry-billings-download-params";
import taxiCorporationPlanEntryBillingsDownloadParamsFactory from "./plan-entry-billings/download/taxi-corporation-plan-entry-billings-download-params.factory";
import TaxiCorporationPlanEntryBillingsDownload from "./plan-entry-billings/download/taxi-corporation-plan-entry-billings-download";
import taxiCorporationPlanEntryBillingsDownloadFactory from "./plan-entry-billings/download/taxi-corporation-plan-entry-billings-download.factory";
import TaxiCorporationOrderBillingsListError from "./order-billings/list/taxi-corporation-order-billings-list-error";
import TaxiCorporationOrderBillingsListParams from "./order-billings/list/taxi-corporation-order-billings-list-params";
import TaxiCorporationOrderBillingsList from "./order-billings/list/taxi-corporation-order-billings-list";
import TaxiCorporationOrderBillingsListRequest from "../../api/raily/taxi-corporation/order-billings/list/taxi-corporation-order-billings-list.request";
import taxiCorporationOrderBillingsListParamsFactory from "./order-billings/list/taxi-corporation-order-billings-list-params.factory";
import taxiCorporationOrderBillingsListFactory from "./order-billings/list/taxi-corporation-order-billings-list.factory";
import TaxiCorporationOrderBillingsDownloadParams from "./order-billings/download/taxi-corporation-order-billings-download-params";
import TaxiCorporationOrderBillingsDownloadError from "./order-billings/download/taxi-corporation-order-billings-download-error";
import TaxiCorporationOrderBillingsDownload from "./order-billings/download/taxi-corporation-order-billings-download";
import TaxiCorporationOrderBillingsDownloadRequest from "../../api/raily/taxi-corporation/order-billings/download/taxi-corporation-order-billings-download.request";
import taxiCorporationOrderBillingsDownloadParamsFactory from "./order-billings/download/taxi-corporation-order-billings-download-params.factory";
import taxiCorporationOrderBillingsDownloadFactory from "./order-billings/download/taxi-corporation-order-billings-download.factory";
import TaxiCorporationUnbilledOrdersListError from "./unbilled/orders-list/taxi-corporation-unbilled-orders-list-error";
import TaxiCorporationUnbilledOrdersListParams from "./unbilled/orders-list/taxi-corporation-unbilled-orders-list-params";
import TaxiCorporationUnbilledOrdersList from "./unbilled/orders-list/taxi-corporation-unbilled-orders-list";
import taxiCorporationUnbilledOrdersListFactory from "./unbilled/orders-list/taxi-corporation-unbilled-orders-list.factory";
import taxiCorporationUnbilledOrdersListParamsFactory from "./unbilled/orders-list/taxi-corporation-unbilled-orders-list-params.factory";
import TaxiCorporationUnbilledRouteList from "./unbilled/route-list/taxi-corporation-unbilled-route-list";
import TaxiCorporationUnbilledRouteListError from "./unbilled/route-list/taxi-corporation-unbilled-route-list-error";
import TaxiCorporationUnbilledRouteListParams from "./unbilled/route-list/taxi-corporation-unbilled-route-list-params";
import taxiCorporationUnbilledRouteListParamsFactory from "./unbilled/route-list/taxi-corporation-unbilled-route-list-params.factory";
import taxiCorporationUnbilledRouteListFactory from "./unbilled/route-list/taxi-corporation-unbilled-route-list.factory";
import TaxiCorporationDriverPlanParams from "./driver/plan/taxi-corporation-driver-plan-params";
import TaxiCorporationDriverPlan from "./driver/plan/taxi-corporation-driver-plan";
import TaxiCorporationDriverPlanRequest from "../../api/raily/taxi-corporation/driver/plan/taxi-corporation-driver-plan.request";
import taxiCorporationDriverPlanLoadParamsFactory from "./driver/plan/taxi-corporation-driver-plan-params.factory";
import taxiCorporationDriverPlanFactory from "./driver/plan/taxi-corporation-driver-plan.factory";
import TaxiCorporationDriverPlanError from "./driver/plan/taxi-corporation-driver-plan-error";
import TaxiCorporationFleetPartnerAddRequest from "../../api/raily/taxi-corporation/fleet-partner/add/taxi-corporation-fleet-partner-add.request";
import TaxiCorporationFleetPartnerUpdateRequest from "../../api/raily/taxi-corporation/fleet-partner/update/taxi-corporation-fleet-partner-update.request";
import TaxiCorporationFleetPartnerAddError from "./fleet-partner/add/taxi-corporation-fleet-partner-add-error";
import TaxiCorporationFleetPartnerAddParams from "./fleet-partner/add/taxi-corporation-fleet-partner-add-params";
import taxiCorporationFleetPartnerAddParamsFactory from "./fleet-partner/add/taxi-corporation-fleet-partner-add-params.factory";
import TaxiCorporationFleetPartnerList from "./fleet-partner/list/taxi-corporation-fleet-partner-list";
import TaxiCorporationFleetPartnerListError from "./fleet-partner/list/taxi-corporation-fleet-partner-list-error";
import TaxiCorporationFleetPartnerListParams from "./fleet-partner/list/taxi-corporation-fleet-partner-list-params";
import taxiCorporationFleetPartnerListFactory from "./fleet-partner/list/taxi-corporation-fleet-partner-list.factory";
import TaxiCorporationFleetPartnerUpdateError from "./fleet-partner/update/taxi-corporation-fleet-partner-update-error";
import TaxiCorporationFleetPartnerUpdateParams from "./fleet-partner/update/taxi-corporation-fleet-partner-update-params";
import taxiCorporationFleetPartnerUpdateParamsFactory from "./fleet-partner/update/taxi-corporation-fleet-partner-update-params.factory";
import handleErrorFactory from "../../utils/handle-error/handle-error.factory";

const getDetails = async (
  params: TaxiCorporationDetailsParams,
  abortSignal: AbortSignal,
) => {
  try {
    const response = await taxiCorporationApiService().getDetails(
      params,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const taxiDetails = taxiCorporationDetailsFactory.create(response);
    return taxiDetails;
  } catch (_error) {
    const error = _error as HttpError | TaxiCorporationDetailsError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getList = async (
  params: TaxiCorporationListParams,
  abortSignal: AbortSignal,
): Promise<TaxiCorporationList> => {
  const request: TaxiCorporationListRequest =
    taxiCorporationListParamsFactory.create(params);

  try {
    const response = await taxiCorporationApiService().getList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return taxiCorporationListFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | TaxiCorporationListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const add = async (
  params: TaxiCorporationAddParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: TaxiCorporationAddRequest =
    taxiCorporationAddParamsFactory.create(params);

  try {
    const response = await taxiCorporationApiService().add(
      request,
      abortSignal,
    );

    if (response.status != 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | TaxiCorporationAddError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getCargoTaxiContractList = async (
  params: TaxiCorporationCargoTaxiContractListParams,
  abortSignal: AbortSignal,
): Promise<TaxiCorporationCargoTaxiContractList> => {
  const request: TaxiCorporationCargoTaxiContractListRequest =
    taxiCorporationCargoTaxiContractListParamsFactory.create(params);

  try {
    const response = await taxiCorporationApiService().getCargoTaxiContractList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return taxiCorporationCargoTaxiContractListFactory.create(response);
  } catch (_error) {
    const error = _error as
      | HttpError
      | TaxiCorporationCargoTaxiContractListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getPlanEntryBillings = async (
  params: TaxiCorporationPlanEntryBillingsParams,
  abortSignal: AbortSignal,
): Promise<TaxiCorporationPlanEntryBillings> => {
  const request = taxiCorporationPlanEntryBillingsParamsFactory.create(params);

  try {
    const response = await taxiCorporationApiService().getPlanEntryBillings(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
    return taxiCorporationPlanEntryBillingsFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | TaxiCorporationPlanEntryBillingsError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const gerOrderBillingsList = async (
  params: TaxiCorporationOrderBillingsListParams,
  abortSignal: AbortSignal,
): Promise<TaxiCorporationOrderBillingsList> => {
  const request: TaxiCorporationOrderBillingsListRequest =
    taxiCorporationOrderBillingsListParamsFactory.create(params);

  try {
    const response = await taxiCorporationApiService().gerOrderBillingsList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
    return taxiCorporationOrderBillingsListFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | TaxiCorporationOrderBillingsListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getUnbilledOrdersList = async (
  params: TaxiCorporationUnbilledOrdersListParams,
  abortSignal: AbortSignal,
): Promise<TaxiCorporationUnbilledOrdersList> => {
  const request =
    taxiCorporationUnbilledOrdersListParamsFactory.createRequest(params);

  try {
    const response = await taxiCorporationApiService().getUnbilledOrdersList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
    return taxiCorporationUnbilledOrdersListFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | TaxiCorporationUnbilledOrdersListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getPlanEntryBillingsReport = async (
  params: TaxiCorporationPlanEntryBillingsDownloadParams,
  abortSignal: AbortSignal,
): Promise<TaxiCorporationPlanEntryBillingsDownload> => {
  const request =
    taxiCorporationPlanEntryBillingsDownloadParamsFactory.create(params);

  try {
    const response =
      await taxiCorporationApiService().getPlanEntryBillingsReport(
        request,
        abortSignal,
      );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return taxiCorporationPlanEntryBillingsDownloadFactory.create(response);
  } catch (_error) {
    const error = _error as
      | HttpError
      | TaxiCorporationPlanEntryBillingsDownloadError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getOrderBillingsReport = async (
  params: TaxiCorporationOrderBillingsDownloadParams,
  abortSignal: AbortSignal,
): Promise<TaxiCorporationOrderBillingsDownload> => {
  const request: TaxiCorporationOrderBillingsDownloadRequest =
    taxiCorporationOrderBillingsDownloadParamsFactory.create(params);

  try {
    const response = await taxiCorporationApiService().getOrderBillingsReport(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return taxiCorporationOrderBillingsDownloadFactory.create(response);
  } catch (_error) {
    const error = _error as
      | HttpError
      | TaxiCorporationOrderBillingsDownloadError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getUnbilledRouteListing = async (
  params: TaxiCorporationUnbilledRouteListParams,
  abortSignal: AbortSignal,
): Promise<TaxiCorporationUnbilledRouteList> => {
  const request =
    taxiCorporationUnbilledRouteListParamsFactory.createRequest(params);

  try {
    const response = await taxiCorporationApiService().getUnbilledRouteList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return taxiCorporationUnbilledRouteListFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | TaxiCorporationUnbilledRouteListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getDriverPlan = async (
  params: TaxiCorporationDriverPlanParams,
  abortSignal: AbortSignal,
): Promise<TaxiCorporationDriverPlan> => {
  const request: TaxiCorporationDriverPlanRequest =
    taxiCorporationDriverPlanLoadParamsFactory.create(params);

  try {
    const response = await taxiCorporationApiService().getDriverPlan(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return taxiCorporationDriverPlanFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | TaxiCorporationDriverPlanError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const addFleetPartner = async (
  params: TaxiCorporationFleetPartnerAddParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: TaxiCorporationFleetPartnerAddRequest =
    taxiCorporationFleetPartnerAddParamsFactory.create(params);

  try {
    const response = await taxiCorporationApiService().addFleetPartner(
      request,
      abortSignal,
    );

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | TaxiCorporationFleetPartnerAddError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getFleetPartnerList = async (
  params: TaxiCorporationFleetPartnerListParams,
  abortSignal: AbortSignal,
): Promise<TaxiCorporationFleetPartnerList> => {
  try {
    const response = await taxiCorporationApiService().getFleetPartnerList(
      params,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const taxiFleetPartnerList =
      taxiCorporationFleetPartnerListFactory.create(response);
    return taxiFleetPartnerList;
  } catch (_error) {
    const error = _error as HttpError | TaxiCorporationFleetPartnerListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const updateFleetPartner = async (
  params: TaxiCorporationFleetPartnerUpdateParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: TaxiCorporationFleetPartnerUpdateRequest =
    taxiCorporationFleetPartnerUpdateParamsFactory.create(params);

  try {
    const response = await taxiCorporationApiService().updateFleetPartner(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | TaxiCorporationFleetPartnerUpdateError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const taxiCorporationService = {
  getList,
  getDetails,
  add,
  getCargoTaxiContractList,
  getPlanEntryBillings,
  getPlanEntryBillingsReport,
  gerOrderBillingsList,
  getOrderBillingsReport,
  getUnbilledOrdersList,
  getUnbilledRouteListing,
  getDriverPlan,
  addFleetPartner,
  getFleetPartnerList,
  updateFleetPartner,
};

export default taxiCorporationService;
